const Systems ="G1BET" 

export default Systems;
